import translate from 'loankeeper-common/helpers/language'

export default (key: string): string => translate(`frm_client_validation_results-${key}`)
